import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';

import { useBoard } from './boards-hooks';
import { useResponsiveConstants } from './responsive/useResponsiveConstants';

export const useShowQuickRemoval = (): {
  shouldShowQuickRemoval: boolean;
} => {
  const { type } = useBoard();

  const homeFeed = useRouteMatch('/feeds/home');
  const linksTab = useRouteMatch('/feeds/:source/links');
  const documentsTab = useRouteMatch('/feeds/:source/documents');
  const mediaTab = useRouteMatch('/feeds/:source/media');
  const webclipsTab = useRouteMatch('/feeds/:source/webclips');
  const sourcePreview = useRouteMatch('/preview/:category/:deeplink');
  const feedsRoute = useRouteMatch('/feeds');

  const { mobile } = useResponsiveConstants();

  const shouldShowQuickRemoval = React.useMemo(() => {
    if (!feedsRoute || homeFeed || mobile || linksTab || sourcePreview) {
      return false;
    }

    if (type === 'sources' && !(documentsTab || mediaTab || webclipsTab)) {
      return true;
    }

    return false;
  }, [
    feedsRoute,
    homeFeed,
    mobile,
    linksTab,
    sourcePreview,
    type,
    documentsTab,
    mediaTab,
    webclipsTab,
  ]);

  return {
    shouldShowQuickRemoval,
  };
};
